<template>
  <div class="page-wrapper">
    <HeaderComponent />
    <div class="page-content">
      <AppBreadcrumb :items="[{ label: 'Bosh sahifa', to: '/' }, { label: 'Mavzular bo\'yicha testlar' }]" />

      <div class="page-header">
        <div class="header-icon">📚</div>
        <div class="header-text">
          <h1>Mavzular bo'yicha testlar</h1>
          <p>YHQ boblari asosida alohida mavzularni o'rganing va test ishlang</p>
        </div>
      </div>

      <div v-if="loading" class="loading-state">
        <a-spin size="large" />
        <p>Mavzular yuklanmoqda...</p>
      </div>

      <div v-else class="topics-list">
        <div v-for="(topic, index) in topics" :key="topic.id" class="topic-row-card" @click="startTopicTest(topic.id)">
          <div class="topic-index">{{ romanize(index + 1) }}</div>
          <div class="topic-info">
            <h3>{{ topic.name }}</h3>
            <span class="q-count">{{ topic.question_count }} ta savol</span>
          </div>
          <div class="topic-action">
            <span class="start-text">Boshlash</span>
            <div class="arrow-btn">→</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import AppBreadcrumb from '@/components/AppBreadcrumb.vue'
import api from '@/api/axios'

export default {
  name: 'TopicsListView',
  components: {
    HeaderComponent,
    AppBreadcrumb
  },
  data() {
    return {
      topics: [],
      loading: true
    }
  },
  async mounted() {
    await this.fetchTopics()
  },
  methods: {
    async fetchTopics() {
      try {
        const response = await api.get('/v1/topics/')
        this.topics = response.data?.topics || []
      } catch (error) {
        console.error("Mavzularni yuklashda xatolik:", error)
      } finally {
        this.loading = false
      }
    },
    startTopicTest(topicId) {
      this.$router.push(`/topic-test/${topicId}`)
    },
    romanize(num) {
      if (isNaN(num)) return NaN;
      var digits = String(+num).split(""),
        key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM",
          "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC",
          "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
        roman = "",
        i = 3;
      while (i--)
        roman = (key[+digits.pop() + (i * 10)] || "") + roman;
      return Array(+digits.join("") + 1).join("M") + roman;
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg);
}

.page-content {
  flex: 1;
  padding: 0 24px 32px;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 24px 0 32px;
  padding: 24px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
}

.header-icon {
  font-size: 48px;
  background: rgba(59, 130, 246, 0.1);
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.header-text h1 {
  font-size: 24px;
  font-weight: 800;
  color: var(--text);
  margin: 0 0 8px;
}

.header-text p {
  font-size: 14px;
  color: var(--text-soft);
  margin: 0;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  gap: 16px;
  color: var(--text-soft);
}

.topics-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.topic-row-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.topic-row-card:hover {
  transform: translateY(-2px);
  border-color: var(--primary);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
}

.topic-index {
  font-size: 16px;
  font-weight: 800;
  color: var(--primary);
  background: rgba(59, 130, 246, 0.1);
  min-width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.topic-info {
  flex: 1;
}

.topic-info h3 {
  font-size: 16px;
  font-weight: 700;
  color: var(--text);
  margin: 0 0 6px;
  line-height: 1.4;
}

.q-count {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-soft);
  background: rgba(255, 255, 255, 0.05);
  padding: 4px 10px;
  border-radius: 20px;
}

.topic-action {
  display: flex;
  align-items: center;
  gap: 12px;
}

.start-text {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-soft);
  transition: color 0.2s;
}

.topic-row-card:hover .start-text {
  color: var(--primary);
}

.arrow-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--bg);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text);
  transition: all 0.2s;
}

.topic-row-card:hover .arrow-btn {
  background: var(--primary);
  border-color: var(--primary);
  color: white;
  transform: translateX(4px);
}

@media (max-width: 768px) {
  .page-content {
    padding: 0 16px 24px;
  }

  .page-header {
    flex-direction: column;
    text-align: center;
    padding: 20px;
    gap: 16px;
  }

  .topic-row-card {
    padding: 16px;
    gap: 12px;
  }

  .topic-index {
    min-width: 40px;
    height: 40px;
    font-size: 14px;
  }

  .topic-info h3 {
    font-size: 14px;
  }

  .start-text {
    display: none;
  }
}
</style>
